import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export const partnerPortalAccessInfoRoutes: Routes = [
    {
        path: advaniaServicesSegments.partnerPortalAccessInfo,
        loadComponent: () =>
            import('./pages/partner-portal-access-info-page/partner-portal-access-info.page').then(
                (m) => m.PartnerPortalAccessInfoPage,
            ),
    },
];
